export default __webpack_public_path__ + "static/media/products-aircare-comp.630be868.png";